import React from "react";
import CartMapView from "./CartMapView";

const CartList = () => {
  return (
    <div className="p-3">
      <CartMapView />
    </div>
  );
};

export default CartList;
